import './Paragraph.scss';

import PropTypes from 'prop-types';
import React from 'react';
import Constants from 'Shared/constants';

const Paragraph = ({ font, centered, className, children, noBreak, color, isDiv, lineThrough }) => {
	return isDiv ? (
		<div
			className={`react__paragraph ${className}`}
			data-centered={centered}
			data-color={color}
			data-font={font}
			data-line-through={lineThrough}
			data-no-break={noBreak}
		>
			{children}
		</div>
	) : (
		<p
			className={`react__paragraph ${className}`}
			data-centered={centered}
			data-color={color}
			data-font={font}
			data-line-through={lineThrough}
			data-no-break={noBreak}
		>
			{children}
		</p>
	);
};

Paragraph.propTypes = {
	font: PropTypes.oneOf([...Constants.PARAGRAPHS, 'inherit']),
	color: PropTypes.oneOf([...Constants.TYPES, 'inherit']),
	centered: PropTypes.bool,
	lineThrough: PropTypes.bool,
	children: PropTypes.node,
	className: PropTypes.string,
	noBreak: PropTypes.bool,
	isDiv: PropTypes.bool
};

Paragraph.defaultProps = {
	font: 'small',
	centered: false,
	className: '',
	children: null,
	noBreak: false,
	lineThrough: false,
	color: 'inherit',
	isDiv: false
};

export default Paragraph;
